import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {DoctorProfileDetailModalComponent} from "./doctor-profile-detail-modal.component";

const routes: Routes = [
  {
    path: '',
    component: DoctorProfileDetailModalComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DoctorProfileDetailModalRoutingModule {}
